export function mapParamsToObject(params, paramsObject) {
    if (Array.isArray(params)) {
        if (params.length === 1 && isObject(params[0])) {
            return handleObjectMapping(params[0], paramsObject);
        } else {
            const paramKeys = Object.keys(paramsObject);
            for (let i=0; i < params.length; i++) {
                paramsObject[paramKeys[i]] = params[i];
            }
        }
        return paramsObject;
    }  else if (isObject(params)) {
        return handleObjectMapping(params, paramsObject);
    } else {
        throw new Error('Invalid params object specified');
    }
}

function isObject(obj) {
    return typeof obj === 'object';
}

function handleObjectMapping(obj, paramsObject) {
    return {
        ...paramsObject,
        ...obj
    };
}
